import { formatToCurrency } from '@mixins/currency';
import Model from '@models/model';

export const CUSTOMER_PURCHASE_ORDER_BLANKET = 'Blanket';
export const CUSTOMER_PURCHASE_ORDER_SINGLE_USE = 'Single Use';
export const CUSTOMER_PURCHASE_ORDER_TYPES = [
    { id: CUSTOMER_PURCHASE_ORDER_BLANKET, text: CUSTOMER_PURCHASE_ORDER_BLANKET },
    { id: CUSTOMER_PURCHASE_ORDER_SINGLE_USE, text: CUSTOMER_PURCHASE_ORDER_SINGLE_USE },
];

export default class CustomerPurchaseOrder extends Model {
    resource() {
        return 'purchase-orders';
    }

    get formFieldCasts() {
        return {
            amount: formatToCurrency,
        };
    }
}
